import { Injectable } from '@angular/core';
import { databases, ID } from '../config/appwrite';
import { environment } from '../../../environments/environment';
import { Query } from 'appwrite';
import { Consentimiento } from '../models/consentimiento.model';
import { CitaService } from './cita.service';

@Injectable({
  providedIn: 'root'
}) 
export class ConsentimientoService {
  private collectionId = "consentimientos";
  private DATABASE_NAME = environment.databaseName;

  constructor(
    private __citasservice: CitaService) {
  }



  

  // Validación si ya tiene alguna cita, si es asi valida si tiene consentimiento informado

  async getConsentimientoConCita(idPaciente: string): Promise<boolean> {
    try {
      const res = await this.__citasservice.getLastCita(idPaciente);
      // Si tiene citas, entonces válida si tiene consentimiento
      if (res) {
        // CONSULTA SI TIENE CONSENTIMIENTO INFORMADO
        const tieneConsentimiento = await this.getConsentimiento(idPaciente);
        if (tieneConsentimiento.length > 0) {
          return true;
        }else{
          return false;
        }
      } else {
        // No tiene citas entonces aún no se valida si tiene consentimiento, por eso siempre retorna true
        return true;
      }
    } catch (error) {
      console.log("error tu especialista::: 1", error);
      return false; // Retorna false en caso de error
    }
  }

  /**
   *getDocumentos
   * @returns
   */
   getConsentimiento(IdPaciente: string): Promise<Consentimiento[]> {
    return databases.listDocuments<Consentimiento>(
      this.DATABASE_NAME,
      this.collectionId,
      [Query.equal('idPaciente', [IdPaciente]),]
    ).then(response => response.documents);
  }
  

  /**
   * @createDocument()
   * @param data
   * @returns
   */
  createDocument(data){
    return databases.createDocument(this.DATABASE_NAME, this.collectionId, ID.unique(), data);
  }

  updateDocument(idDiagnostico, data){
    data.$databaseId = undefined;
    data.$collectionId = undefined;
    return databases.updateDocument(this.DATABASE_NAME, this.collectionId, idDiagnostico, data);
  }
  getDocument(idDocument: string) {
    return databases.getDocument(this.DATABASE_NAME, this.collectionId, idDocument);
  }

}
